
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/announcements/cinch-news",
      function () {
        return require("private-next-pages/announcements/cinch-news/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/announcements/cinch-news"])
      });
    }
  